import { useCallback, useRef } from "react";

function useFormTextRender(tranlateFn) {
	const formStateRef = useRef();

	const textRender = useCallback(
		key => tranlateFn(key, formStateRef.current),
		[tranlateFn], // deps
	);

	return [textRender, formStateRef];
}

export default useFormTextRender;
